import { usePageTitle } from '../hooks/usePageTitle';

export const PageTitle = () => {
  usePageTitle();
  return null;
};
